/* eslint-disable */
import { assetImages } from "constants";
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import * as url from "helper/UrlHelper";

const LeftMenuPanelPopup = ({ moduleName, userInfo }) => {
  const { t } = useTranslation(); // Translation hook
  const moduleAccess = localStorage.getItem("moduleaccess") || ""; // Get module access permissions
  const userRole = userInfo?.role?.slug || ""; // Extract user role

  // Construct user image URL with fallback
  const userImage = userInfo?.photoimage
    ? url.SERVER_URL + userInfo.photoimage.path
    : assetImages?.defaultUser;

  // Check if user is admin
  const isAdmin = ["ADMIN", "SUPER_ADMIN"].includes(userRole);

  // Check module access permissions
  const hasModuleAccess = (moduleKey) =>
    isAdmin || moduleAccess.includes(moduleKey);

  /**
   * Menu Configuration Array
   *
   * Structure:
   *   path: Route path
   *   icon: Material icon name
   *   label: Translation key
   *   module: Module identifier for active state
   *   show: Conditional display (true = always show, false = never show, function = conditional)
   *
   * Add new menu items here following the same structure
   */
  const menuItems = [
    // Always visible items
    {
      path: "/admin/dashboard",
      icon: "grid_view",
      label: "Dashboard",
      module: "dashboard",
    },
    {
      path: "/admin/directaccess",
      icon: "switch_access_2",
      label: "Direct Access",
      module: "directaccess",
    },

    // Conditional items
    {
      path: "/admin/administration",
      icon: "admin_panel_settings",
      label: "Administration",
      module: "administration",
      show: isAdmin,
    },
    {
      path: "/admin/appuser/list",
      icon: "person",
      label: "App Users",
      module: "appuser",
      show: isAdmin,
    },
    // {
    //   path: "/admin/clinicalmanagement/doctors",
    //   icon: "person",
    //   label: "Clinical Management",
    //   module: "clinicalmanagement",
    //   show: hasModuleAccess("MOD_CLINIC_MANAGEMENT"),
    // },
    {
      path: "/admin/patientmanagement/prescriptions",
      icon: "person",
      label: "Patient Services",
      module: "patientmanagement",
      show: hasModuleAccess("MOD_PATIENT_MANAGEMENT"),
    },
    {
      path: "/admin/crm/lead/list",
      icon: "space_dashboard",
      label: "CRM",
      module: "crm",
      show: hasModuleAccess("MOD_CRM"),
    },
    {
      path: "/admin/companies",
      icon: "meeting_room",
      label: "Companies",
      module: "companies",
      show: hasModuleAccess("MOD_COMPANY"),
    },
    {
      path: "/admin/events/list",
      icon: "calendar_today",
      label: "Events",
      module: "events",
      show: hasModuleAccess("MOD_EVENT"),
    },
    {
      path: "/admin/group/list",
      icon: "diversity_2",
      label: "Groups",
      module: "group",
      show: hasModuleAccess("MOD_GROUP"),
    },
    {
      path: "/admin/survey/list",
      icon: "live_help",
      label: "Survey",
      module: "survey",
      show: hasModuleAccess("MOD_SURVEY"),
    },
    {
      path: "/admin/projectmanagement/dashboard",
      icon: "contract",
      label: "Project Management",
      module: "projects",
      show: hasModuleAccess("MOD_PROJECT"),
    },
    {
      path: "/admin/mytasklist",
      icon: "task",
      label: "Task Management",
      module: "mytask",
      show: hasModuleAccess("MOD_TASK"),
    },
    {
      path: "/admin/alllogs/list",
      icon: "timer",
      label: "Task Logs",
      module: "alllogs",
      show: hasModuleAccess("MOD_LOGS"),
    },
    {
      path: "/admin/workingtasks",
      icon: "task",
      label: "Task Working",
      module: "taskworking",
      show: hasModuleAccess("MOD_TASK"),
    },
    {
      path: "/admin/challenges/dashboard",
      icon: "work",
      label: "Challenges",
      module: "challenges",
      show: hasModuleAccess("MOD_CHALLENGE"),
    },
    {
      path: "/admin/courses",
      icon: "local_library",
      label: "Courses",
      module: "courses",
      show: hasModuleAccess("MOD_COURSE"),
    },
    {
      path: "/admin/marketplace/products/list",
      icon: "storefront",
      label: "Marketplace",
      module: "marketplace",
      show: hasModuleAccess("MOD_MARKETPLACE"),
    },
    {
      path: "/admin/blogs/list",
      icon: "article",
      label: "Blog",
      module: "blogs",
      show: hasModuleAccess("MOD_CMS"),
    },
    {
      path: "/admin/invoice/list",
      icon: "point_of_sale",
      label: "Invoices",
      module: "invoice",
      show: hasModuleAccess("MOD_INVOICE"),
    },
    {
      path: "/admin/invoicedoc/list",
      icon: "point_of_sale",
      label: "Invoice Docs",
      module: "invoicedoc",
      show: isAdmin,
    },
    {
      path: "/admin/payment/list",
      icon: "euro",
      label: "Payments",
      module: "payment",
      show: hasModuleAccess("MOD_PAYMENT"),
    },
    {
      path: "/admin/subscription/list",
      icon: "card_membership",
      label: "Subscription",
      module: "subscription",
      show: hasModuleAccess("MOD_SUBSCRIPTION"),
    },
    {
      path: "/admin/tickets/list",
      icon: "transit_ticket",
      label: "Tickets",
      module: "tickets",
      show: hasModuleAccess("MOD_TICKET"),
    },

    {
      path: "/admin/faq/list",
      icon: "quiz",
      label: "FAQ",
      module: "faq",
      show: hasModuleAccess("MOD_FAQ"),
    },
    {
      path: "/admin/automation/list",
      icon: "quiz",
      label: "Automation",
      module: "automation",
      // show: hasModuleAccess("MOD_AUTOMATION"),
      show: false,
    },
  ];

  return (
    <div
      className="offcanvas offcanvas-start bg-white border-0 shadow-lg"
      data-bs-scroll="true"
      data-bs-backdrop="true"
      tabIndex="-1"
      id="offcanvasMainNav"
      aria-labelledby="offcanvasMainNavLabel"
      style={{ width: "320px" }}
    >
      {/* ----- Enhanced Header Section ----- */}
      <div
        className="offcanvas-header flex-column align-items-start p-0 border-bottom border-gray-300"
        style={{
          background:
            "linear-gradient(135deg, rgba(238, 82, 60, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%)",
        }}
      >
        {/* Close button with enhanced styling */}
        <div className="w-100 d-flex justify-content-end p-3 pb-0 mb-2">
          <button
            type="button"
            className="btn btn-outline-primary rounded-circle d-flex align-items-center justify-content-center border-2"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            style={{
              width: "40px",
              height: "40px",
              transition: "all 0.3s ease-in-out",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "var(--bs-primary)";
              e.currentTarget.style.color = "white";
              e.currentTarget.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "var(--bs-primary)";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <span className="material-symbols-outlined fs-md">arrow_back</span>
          </button>
        </div>

        {/* Enhanced User Profile Section */}
        <div className="user w-100 p-4 pt-2">
          <div className="d-flex align-items-center gap-3 p-3 bg-white rounded-15 shadow-sm border border-gray-300">
            <div
              className="avatar rounded-circle overflow-hidden border-3 border-primary shadow-sm"
              style={{ width: "60px", height: "60px" }}
            >
              <img
                src={userImage}
                alt="UserImage"
                className="w-100 h-100 object-fit-cover object-center"
              />
            </div>
            <div className="name flex-fill">
              <h6 className="fw-bold mb-1 text-dark ps-1">
                {userInfo.name} {userInfo.surname}
              </h6>
              <p className="fs-sm text-muted mb-1 ps-1">{userInfo.position}</p>
              {/* <span className="badge border border-primary text-primary fs-xs px-3 py-1 rounded-pill">
                {userRole}
              </span> */}
            </div>
          </div>
        </div>
      </div>

      {/* ----- Enhanced Navigation Menu ----- */}
      <div
        className="offcanvas-body p-0"
        style={{ backgroundColor: "var(--bs-gray-200)" }}
      >
        <div className="p-4">
          <h6
            className="text-muted fw-bold mb-3 text-uppercase ls-1"
            style={{ fontSize: "0.75rem", letterSpacing: "1px" }}
          >
            {t("Navigation")}
          </h6>

          <nav className="nav flex-column gap-1">
            {/*
              Enhanced Dynamic Menu Rendering:
              - Filters menu items based on 'show' condition
              - Maps remaining items to styled Link components with hover effects
              - Highlights active module with enhanced styling
            */}
            {menuItems.map((item) => {
              if (item.show === false) return null;
              const isActive = moduleName === item.module;

              return (
                <div className="nav-item" key={item.path}>
                  <Link
                    to={item.path}
                    className={`nav-link d-flex align-items-center gap-3 px-3 py-3 rounded-10 text-decoration-none transition-all ${
                      isActive
                        ? "bg-primary text-white shadow-sm"
                        : "text-dark bg-white border border-gray-300 shadow-sm"
                    }`}
                    aria-current={isActive ? "page" : undefined}
                    style={{
                      transition: "all 0.3s ease-in-out",
                      fontWeight: "500",
                    }}
                    onMouseEnter={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor =
                          "rgba(238, 82, 60, 0.1)";
                        e.currentTarget.style.borderColor = "var(--bs-primary)";
                        e.currentTarget.style.transform = "translateX(5px)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 15px rgba(0, 0, 0, 0.1)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor = "white";
                        e.currentTarget.style.borderColor =
                          "var(--bs-gray-300)";
                        e.currentTarget.style.transform = "translateX(0)";
                        e.currentTarget.style.boxShadow =
                          "0 1px 6px rgba(62, 96, 147, 0.18)";
                      }
                    }}
                  >
                    <div
                      className={`d-flex align-items-center justify-content-center rounded-8 ${
                        isActive ? "bg-white bg-opacity-20" : "bg-primary"
                      }`}
                      style={{ width: "35px", height: "35px" }}
                    >
                      <span
                        className={`material-symbols-outlined fs-md  ${
                          isActive ? "text-primary" : "text-white"
                        }`}
                      >
                        {item.icon}
                      </span>
                    </div>
                    <span className="flex-fill fw-semibold">
                      {t(item.label)}
                    </span>
                    {isActive && (
                      <span className="material-symbols-outlined fs-sm text-white">
                        chevron_right
                      </span>
                    )}
                  </Link>
                </div>
              );
            })}
          </nav>
        </div>

        {/* Footer Section */}
        <div className="mt-auto p-4 border-top border-gray-300 bg-white">
          <div className="text-center">
            <p className="fs-xs text-muted mb-2">
              {t("Powered by")}{" "}
              <span className="fw-bold text-primary">LOBEES</span>
            </p>
            <div className="d-flex justify-content-center gap-2">
              <span className="badge bg-danger-subtle text-primary fs-xs px-2 py-1 rounded-pill">
                v2.0
              </span>
              <span className="badge border border-primary text-primary fs-xs px-2 py-1 rounded-pill">
                {t("Backend Version")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftMenuPanelPopup;
